<div class="container bulkUploadForm" style="padding: 5%">
  <div class="col-md-4">
    <h1>Upload Member</h1>
    <p style="font-style: italic">
      Please make sure the uploaded document will be .xls or .xlsx
    </p>
    <br />
    <p style="font-style: italic">Maximum size is 10MB</p>
    <form [formGroup]="bulkUploadForm" (ngSubmit)="onSubmit()" novalidate>
      <input class="fileUpload form-control" style="margin-bottom: 8%" id="uploadForm" type="file"
        (change)="onFileSelect($event)" />

      <button *ngIf="isButtonRole=='PgZgwVDYuHRwWlI023sGDg=='" [disabled]="isButtonDisabled" class="btn btn-primary"
        type="submit">Submit 
        <span> <img *ngIf="isLoading" src="assets/images/spinner.gif" style="width: 20px;" /></span>
      </button>
    </form>
    <div>
     
    </div>
    <small class="text-danger" *ngIf="isErrorMessage">
      Please check again your file type and size!
    </small>
    <small class="text-danger" *ngIf="isServerError">
      Upload Failed!
    </small>
    <small class="text-success" *ngIf="isUploadSuccess">
      Upload Success!
    </small>
  </div>
</div>